<template>
  <div>
    <v-card>
      <v-alert v-if="record.actualizado" dark color="warning"
        >Registro Actualizado</v-alert
      >
      <v-alert v-if="record.nuevo" dark color="success"
        >Registro Creado</v-alert
      >
      <v-card-title>
        Periodo de Inscripción
        <v-btn link icon absolute top right @click="cerrar"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-autocomplete
            v-if="!model.id"
            outlined
            v-model="carrerasSeleccionadas"
            :items="carreras"
            item-text="nombre"
            item-value="id"
            label="Carreras"
            multiple
            chips
            deletable-chips
            :error-messages="errors.carrera_id"
          ></v-autocomplete>
          <v-select
            v-else
            outlined
            v-model="model.carrera_id"
            :items="carreras"
            item-text="nombre"
            item-value="id"
            label="Carrera"
            :error-messages="errors.carrera_id"
          ></v-select>

          <v-text-field
            outlined
            v-model="model.nombre"
            label="Nombre"
            :error-messages="errors.nombre"
          ></v-text-field>

          <v-switch
            :true-value="1"
            :false-value="0"
            v-model="model.activo"
            label="Activo (se muestra en la web; al activar este se desactivan los demás de la carrera)"
          ></v-switch>

          <v-text-field
            outlined
            type="date"
            v-model="model.inicio_cuatrimestre"
            label="Inicio del Cuatrimestre"
            :error-messages="errors.inicio_cuatrimestre"
          ></v-text-field>

          <div class="subtitle-2 mb-1">Período de Inscripción</div>
          <v-row>
            <v-col cols="6">
              <v-text-field
                outlined
                type="date"
                v-model="model.fecha_inicio_inscripcion"
                label="Desde"
                :error-messages="errors.fecha_inicio_inscripcion"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                type="date"
                v-model="model.fecha_fin_inscripcion"
                label="Hasta"
                :error-messages="errors.fecha_fin_inscripcion"
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="subtitle-2 mb-1">Período de Enmiendas</div>
          <v-row>
            <v-col cols="6">
              <v-text-field
                outlined
                type="date"
                v-model="model.enmiendas_desde"
                label="Desde"
                :error-messages="errors.enmiendas_desde"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                type="date"
                v-model="model.enmiendas_hasta"
                label="Hasta"
                :error-messages="errors.enmiendas_hasta"
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="subtitle-2 mb-1">Renuncia a Cursados Vigentes</div>
          <v-row>
            <v-col cols="6">
              <v-text-field
                outlined
                type="date"
                v-model="model.renuncia_desde"
                label="Desde"
                :error-messages="errors.renuncia_desde"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                type="date"
                v-model="model.renuncia_hasta"
                label="Hasta"
                :error-messages="errors.renuncia_hasta"
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="subtitle-2 mb-1">Estudiante Oyente</div>
          <v-row>
            <v-col cols="6">
              <v-text-field
                outlined
                type="date"
                v-model="model.oyente_desde"
                label="Desde"
                :error-messages="errors.oyente_desde"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                type="date"
                v-model="model.oyente_hasta"
                label="Hasta"
                :error-messages="errors.oyente_hasta"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-text-field
            outlined
            v-model="model.horario_url"
            label="Horario de Cursada (URL del PDF)"
            :error-messages="errors.horario_url"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn @click="guardar" color="primary">Guardar</v-btn>
        </div>
        <v-spacer></v-spacer>
        <div>
          <v-btn @click="cerrar">Cancelar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "PeriodoInscripcionForm",
  props: {
    id: [String, Number],
  },
  data() {
    return {
      model: {
        carrera_id: null,
        activo: 1,
      },
      carrerasSeleccionadas: [],
    };
  },
  computed: {
    ...mapGetters("PeriodoInscripcionModule", ["errors"]),
    ...mapState("PeriodoInscripcionModule", [
      "fields",
      "periodoInscripcion",
      "record",
    ]),
    ...mapState("CarreraModule", ["carreras"]),
  },
  methods: {
    ...mapActions("PeriodoInscripcionModule", [
      "getFields",
      "getPeriodoInscripcion",
      "updatePeriodoInscripcion",
      "addPeriodoInscripcion",
    ]),
    ...mapActions("CarreraModule", ["getCarreras"]),

    async getModel() {
      await this.getPeriodoInscripcion(this.id);
      this.model = { ...this.periodoInscripcion };
    },

    async guardar() {
      if (this.model.id) {
        await this.updatePeriodoInscripcion(this.model);
      } else {
        for (const carreraId of this.carrerasSeleccionadas) {
          const periodoData = {
            ...this.model,
            carrera_id: carreraId,
          };
          await this.addPeriodoInscripcion(periodoData);
        }
      }
    },

    cerrar() {
      this.record.actualizado = false;
      this.record.nuevo = false;
      this.$emit("close");
    },
  },
  watch: {
    id() {
      if (this.id) {
        this.getModel();
      }
    },
  },
  created() {
    this.getFields();
    this.getCarreras();
    if (this.id) {
      this.getModel();
    }
  },
};
</script>

<style scoped></style>
